// Maps free-text country names (e.g. SRA/BioSample `geo_loc_name_country_calc`)
// to the ISO 3166-1 alpha-3 ids used by world_countries.json.
import { COUNTRY_CODES } from './COUNTRY_CODES';
import worldGeoJson from './world_countries.json';

const norm = (s) =>
  String(s || '')
    .toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

// Names NCBI uses that differ from our map files.
const ALIASES = {
  'usa': 'USA', 'united states of america': 'USA', 'us': 'USA',
  'uk': 'GBR', 'great britain': 'GBR', 'england': 'GBR', 'scotland': 'GBR', 'wales': 'GBR', 'northern ireland': 'GBR',
  'russian federation': 'RUS',
  'korea': 'KOR', 'republic of korea': 'KOR', 'korea south': 'KOR',
  'korea north': 'PRK', 'democratic people s republic of korea': 'PRK',
  'viet nam': 'VNM',
  'czechia': 'CZE',
  'iran islamic republic of': 'IRN',
  'turkiye': 'TUR',
  'democratic republic of the congo': 'COD', 'drc': 'COD',
  'republic of the congo': 'COG',
  'ivory coast': 'CIV',
  'lao people s democratic republic': 'LAO',
  'syrian arab republic': 'SYR',
  'united republic of tanzania': 'TZA',
  'macedonia': 'MKD',
  'swaziland': 'SWZ', 'eswatini': 'SWZ',
  'brunei darussalam': 'BRN',
  'burma': 'MMR',
  'the gambia': 'GMB', 'the bahamas': 'BHS',
  'cabo verde': 'CPV',
  'east timor': 'TLS',
  'kosovo': 'XXK',
  'palestine': 'PSX', 'west bank': 'PSX', 'gaza strip': 'PSX',
  'puerto rico': 'PRI', 'greenland': 'GRL', 'western sahara': 'ESH',
  'french guiana': 'GUF', 'new caledonia': 'NCL',
  'hong kong': 'CHN', 'macau': 'CHN',
};

const LOOKUP = (() => {
  const m = {};
  Object.entries(COUNTRY_CODES).forEach(([iso, { name }]) => { m[norm(name)] = iso; });
  const geoms = Object.values(worldGeoJson.objects || {})[0]?.geometries || [];
  geoms.forEach((g) => { if (g.id && g.properties?.name) m[norm(g.properties.name)] = g.id; });
  Object.entries(ALIASES).forEach(([k, iso]) => { m[norm(k)] = iso; });
  return m;
})();

/** Returns an ISO alpha-3 code, or null when the name can't be placed on the map. */
export function countryNameToIso(name) {
  return LOOKUP[norm(name)] || null;
}
